(function () {
  const accordion = document.querySelector('[data-selector="accordion"]');
  if (!accordion) return;

  const items = accordion.querySelectorAll('[data-selector="accordion-item"]');

  items.forEach(item => {
    const head = item.querySelector('.accordion__head');
    if (!head) return;

    head.addEventListener('click', () => {
      item.classList.toggle('accordion__head_open');
    });
  });
})();
